import { render, staticRenderFns } from "./QuoteAnnotations.vue?vue&type=template&id=1b6f98c8"
import script from "./QuoteAnnotations.vue?vue&type=script&lang=js"
export * from "./QuoteAnnotations.vue?vue&type=script&lang=js"
import style0 from "./QuoteAnnotations.vue?vue&type=style&index=0&id=1b6f98c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports